module.exports = __webpack_public_path__ + "static/media/Stay-focused.17838ebd.png";